import React from 'react'
import cycling from "../../../assets/images/pricingImg/Cycling Together.png";
import PhoneInput from "react-phone-input-2";

const PricingMain = () => {
  return (
    <section className="pricing_banner container-fluid">
    <div className="row">
      <div className="col-md-6 col-lg-6 col-sm-6 pricing-main-heads" >
        <h1 className="get-a-quote" data-aos='fade-left'>Get a quote</h1>

        <p className="get-a-quote-p mt-3" data-aos='fade-left'>
          Whether your team is of 25 or 25,000, Oxyzn is customised to suit
          your business.
        </p>
        <p className="get-a-quote-p" data-aos='fade-left'>
          That’s why our pricing varies, so we’ll need to have a quick chat
          to assess your needs.
        </p>

        <img className="w-100" data-aos='fade-right' src={cycling} alt="" />
      </div>
      <div className="col-md-6 col-lg-6 col-sm-6 ">
        <div className="pricing-from-sec ">
          <form action="">
            <div className=" pricing-inputs-div">
              <div className="">
                <label htmlFor="name">Your name</label>
              </div>
              <input
                className="inputs-text"
                type="text"
                name="name"
                defaultValue="Johnatan Sn"
              />
            </div>
            <div className=" pricing-inputs-div">
              <div className="mt-4">
                <label htmlFor="name">Mobile number</label>
              </div>
              <PhoneInput
                inputClass="know-schedule-inputs"
                enableSearch={true}
                country={"gb"}
                // value={contact_us}
                // onChange={(e) => setcontact_us(e)}
              />
            </div>
            <div className=" pricing-inputs-div ">
              <div className="mt-4">
                <label htmlFor="name">Select your seniority</label>
              </div>
              <select name="" id="">
                <option value="Select...">Select...</option>
                <option value=""></option>
                <option value=""></option>
              </select>
            </div>

            
            <div className=" pricing-inputs-div">
              <div className="mt-4">
                <label htmlFor="name">Company name</label>
              </div>
              <input className="inputs-text" type="text" name="name " />
            </div>
            <div className=" pricing-inputs-div">
              <div className="mt-4">
                <label htmlFor="name">Company size</label>
              </div>
              <select name="" id="">
                <option value="Select...">Select...</option>
                <option value=""></option>
                <option value=""></option>
              </select>
            </div>
            <div className=" pricing-inputs-div">
              <div className="mt-4">
                <label htmlFor="name">
                  Number of companies you have employees in
                </label>
              </div>
              <input className="inputs-text" type="text" name="name " />
            </div>
            <div className=" pricing-inputs-div">
              <div className="mt-4">
                <label htmlFor="name">Select your country</label>
              </div>
              <select name="" id="">
                <option value="Select...">Select...</option>
                <option value=""></option>
                <option value=""></option>
              </select>
            </div>

            <div className="pricing-inputs-div d-flex mt-5">
              <div>
                <div class="container">
                  <div class="round">
                    <input type="checkbox"  id="checkbox" />
                    <label for="checkbox"></label>
                  </div>
                </div>
              </div>
              <div className="pricing-check-text  ms-3">
                By filling in this form you are opting in to receive our HR
                insights, resources and webinars straight into your inbox.
                You are able to change your preferences at anytime.
              </div>
            </div>

            <div className=" pricing-inputs-div">
              <div className="mt-4">
                <button className="">Get a quote</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  )
}

export default PricingMain
